// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2YPVQ","clinicsSelect":"styles_clinicsSelect__3Q5ux"};